import React from 'react';
import PropTypes from 'prop-types';

export class TaskListOption extends React.Component {
	constructor(props, context) {
		super(props, context);

		this.state = {
			isLoading: false,
			showLocationSelectorDrawer: false,
		};
	}

	handleMouseDown = (event) => {
		event.preventDefault();
		event.stopPropagation();
		this.props.onSelect(this.props.option, event);
	};

	handleMouseEnter = (event) => {
		this.props.onFocus(this.props.option, event);
	};

	handleMouseMove = (event) => {
		if (this.props.isFocused) return;
		this.props.onFocus(this.props.option, event);
	};

	render() {
		const itemStyle = this.props.option.isSeparator ? { borderTopWidth: '1px', borderTopStyle: 'solid', borderTopColor: '#DEE2E6' } : {};

		return (
			<div
				className={this.props.className}
				onMouseDown={this.handleMouseDown}
				onMouseEnter={this.handleMouseEnter}
				onMouseMove={this.handleMouseMove}
				title={this.props.option.title}
				style={itemStyle}>
				{this.props.option.itemIcon && <i className={`fa-regular fa-${this.props.option.itemIcon} me-1`}></i>} {this.props.children}
			</div>
		);
	}
}

TaskListOption.propTypes = {
	children: PropTypes.node,
	className: PropTypes.string,
	isDisabled: PropTypes.bool,
	isFocused: PropTypes.bool,
	isSelected: PropTypes.bool,
	onFocus: PropTypes.func,
	onSelect: PropTypes.func,
	option: PropTypes.object.isRequired,
};

export default TaskListOption;
